<div class="toast-content">
  <mat-icon [fontIcon]="icon" [class]="data.action" />
  <div class="text">
    <div class="action">{{ data.action }}</div>
    <div class="message">{{ data.message ? data.message : 'internal server error' }}</div>
  </div>
</div>
